import { orderInvoiceClient } from '@/api/clients';
import { INVOICES } from '@/store/entities/schema_types';

export default function makeOrderInvoiceModule(orderId) {
  return {
    namespaced: true,
    state: {
      fetching: false,
      invoiceId: null,
    },
    mutations: {
      SET_FETCHING(state, payload) {
        state.fetching = Boolean(payload.fetching);
      },
      SET_INVOICE_ID(state, payload) {
        state.invoiceId = payload.invoiceId;
      },
    },
    actions: {
      async fetchInvoice(ctx, { params = {} } = {}) {
        try {
          const response = await orderInvoiceClient.list(orderId, { params });

          const { data } = response.data;

          if (data === null) {
            return Promise.resolve(true);
          }

          const invoiceId = await ctx.dispatch(
            'entities/persistEntities',
            { type: INVOICES, data },
            { root: true }
          );

          ctx.commit({
            type: 'SET_INVOICE_ID',
            invoiceId,
          });

          return Promise.resolve(true);
        } catch (error) {
          return Promise.reject(error);
        }
      },
      async storeInvoice(ctx) {
        if (ctx.state.invoiceId !== null) {
          return Promise.resolve(ctx.state.invoiceId);
        }

        try {
          const response = await orderInvoiceClient.store(orderId);

          const { data } = response.data;

          const invoiceId = await ctx.dispatch(
            'entities/persistEntities',
            { type: INVOICES, data },
            { root: true }
          );

          ctx.commit({
            type: 'SET_INVOICE_ID',
            invoiceId,
          });

          return Promise.resolve(invoiceId);
        } catch (error) {
          return Promise.reject(error);
        }
      },
    },
  };
}
